import { useState } from "react";
import logo from "../../asset/johura_logo.png";
import BackgroundImage from "../../asset/login-banner.jpg";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";
import { API_BASE_URL } from "../../components/baseUrl";

const Login = () => {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [pass, setPass] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const data = { email, pass };
      const response = await axios.post(`${API_BASE_URL}/api/login`, data);
      const accessToken = await response?.data?.token;
      localStorage.setItem("accessToken", accessToken);
      const user = await response?.data?.user;
      localStorage.setItem("user", JSON.stringify(user));

      if (response) {
        navigate("/dashboard");
      }
    } catch (error) {
      setError(error?.message || error?.response?.data?.error);
    }
  };

  return (
    <div className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Blurred background layer */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url(${BackgroundImage})`,
          // filter: "blur(2px)",
          zIndex: -1,
        }}
      ></div>

      {/* Foreground content */}
      <div className="z-10 bg-white opacity-90 rounded-xl shadow-md w-[500px] p-5 m-5">
        <img
          src={logo}
          alt="logo"
          className="h-20 bg-white rounded-full object-contain mx-auto w-full border mb-5 px-3"
        />
        <form onSubmit={handleSubmit} className="w-full">
          <div>
            <label className="font-semibold">Email</label>
            <input
              onChange={(e) => setEmail(e.target.value)}
              type="text"
              className="border rounded h-10  w-full px-2"
            />
          </div>
          <div className="my-2 relative">
            <label className="font-semibold">Password</label>
            <input
              onChange={(e) => setPass(e.target.value)}
              type={showPassword ? "text" : "password"}
              className="border rounded h-10 w-full px-2 "
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="absolute top-[34px] right-3 text-gray-600 focus:outline-none"
            >
              {!showPassword ? (
                <FaRegEye size={20} />
              ) : (
                <FaRegEyeSlash size={20} />
              )}
            </button>
          </div>

          {error && (
            <p className="text-center text-red-500 font-bold my-2">{error}</p>
          )}
          <button
            type="submit"
            className="h-10 bg-blue-600 text-white font-bold cursor-pointer border border-blue-600 w-full rounded mt-2"
          >
            Login
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
